/** Deep-link Gate 2 connector cards to the matching Gate 1 readiness surface. */

export const GATE1_CONNECTOR_SURFACE = Object.freeze({
  api: "api",
  vector: "vector",
  traces: "traces",
});

export const GATE1_CONNECTOR_ELEMENT_ID = Object.freeze({
  api: "gate1-surface-api",
  vector: "gate1-surface-vector",
  traces: "gate1-surface-traces",
});

export function gate1ReadinessConnectorPath(projectId, surface) {
  const id = encodeURIComponent(String(projectId || ""));
  const key = String(surface || "").trim();
  if (!key) return `/readiness/${id}`;
  return `/readiness/${id}?surface=${encodeURIComponent(key)}`;
}
